/* global ol */
function convCoord({ lat, lon }) {
  return ol.proj.transform(
    [lon, lat], 'EPSG:4326', 'EPSG:3857'
  )
}

export default {
  methods: {
    getRoadInfos_() {
      return [
        {
          name: '1号上野線',
          coords: [[
            // from left bottom, clockwise
            { lat: 35.683197, lon: 139.776173 },
            { lat: 35.691615, lon: 139.773756 },
            { lat: 35.711201, lon: 139.775387 },
            { lat: 35.717159, lon: 139.780537 },
            { lat: 35.716288, lon: 139.782082 },
            { lat: 35.710922, lon: 139.778563 },
            { lat: 35.691946, lon: 139.776977 },
            { lat: 35.685485, lon: 139.777974 },
            { lat: 35.684090, lon: 139.780978 },
            { lat: 35.683245, lon: 139.780806 },
          ]]
        },
        {
          name: '1号羽田線',
          coords: [[
            // from left top, counter clockwise
            { lat: 35.653850, lon: 139.758815 },
            { lat: 35.636046, lon: 139.749462 },
            { lat: 35.589993, lon: 139.736244 },
            { lat: 35.561510, lon: 139.745342 },
            { lat: 35.545031, lon: 139.740879 },
            { lat: 35.543774, lon: 139.744998 },
            { lat: 35.558997, lon: 139.756843 },
            { lat: 35.562767, lon: 139.757530 },
            { lat: 35.591249, lon: 139.743625 },
            { lat: 35.605766, lon: 139.752208 },
            { lat: 35.638837, lon: 139.754783 },
            { lat: 35.653901, lon: 139.762354 },
          ]]
        },
        {
          name: '2号目黒線',
          coords: [[
            // from left top, counter clockwise
            { lat: 35.657053, lon: 139.736761 },
            { lat: 35.648527, lon: 139.734860 },
            { lat: 35.647132, lon: 139.722071 },
            { lat: 35.640506, lon: 139.715290 },
            { lat: 35.618600, lon: 139.716578 },
            { lat: 35.618321, lon: 139.722243 },
            { lat: 35.638553, lon: 139.722071 },
            { lat: 35.644342, lon: 139.726620 },
            { lat: 35.646086, lon: 139.737864 },
            { lat: 35.657733, lon: 139.739494 },
          ]]
        },
        {
          name: '3号渋谷線',
          coords: [[
            // from right top, counter clock wise
            { lat: 35.667713, lon: 139.738618 },
            { lat: 35.661080, lon: 139.723419 },
            { lat: 35.659092, lon: 139.702090 },
            { lat: 35.656494, lon: 139.693022 },
            { lat: 35.644359, lon: 139.669161 },
            { lat: 35.634802, lon: 139.659548 },
            { lat: 35.626570, lon: 139.637661 },
            { lat: 35.628803, lon: 139.624700 },
            { lat: 35.626082, lon: 139.624443 },
            { lat: 35.622384, lon: 139.637232 },
            { lat: 35.630617, lon: 139.660063 },
            { lat: 35.635221, lon: 139.667616 },
            { lat: 35.642336, lon: 139.673538 },
            { lat: 35.652798, lon: 139.694652 },
            { lat: 35.656564, lon: 139.703922 },
            { lat: 35.658377, lon: 139.723835 },
            { lat: 35.665351, lon: 139.737911 },
            { lat: 35.664636, lon: 139.740027 },
            { lat: 35.667216, lon: 139.740242 },
          ]]
        },
        {
          name: '4号新宿線',
          coords: [[
            // from right top, counter clock wise
            { lat: 35.683165, lon: 139.744493 },
            { lat: 35.681945, lon: 139.741232 },
            { lat: 35.679819, lon: 139.740760 },
            { lat: 35.679366, lon: 139.733893 },
            { lat: 35.681876, lon: 139.733206 },
            { lat: 35.682852, lon: 139.726984 },
            { lat: 35.680917, lon: 139.722035 },
            { lat: 35.685449, lon: 139.690192 },
            { lat: 35.669831, lon: 139.641783 },
            { lat: 35.672271, lon: 139.626162 },
            { lat: 35.676385, lon: 139.620669 },
            { lat: 35.679383, lon: 139.612944 },
            { lat: 35.676873, lon: 139.612086 },
            { lat: 35.669413, lon: 139.623501 },
            { lat: 35.664636, lon: 139.640158 },
            { lat: 35.678372, lon: 139.694800 },
            { lat: 35.678825, lon: 139.722722 },
            { lat: 35.680917, lon: 139.728816 },
            { lat: 35.677849, lon: 139.732936 },
            { lat: 35.678895, lon: 139.744780 },
            { lat: 35.676228, lon: 139.748742 },
            { lat: 35.676124, lon: 139.750673 },
            { lat: 35.678180, lon: 139.750888 },
          ]]
        },
        {
          name: '5号池袋線（東京東地区）',
          coords: [[
            // from left bottom, clock wise
            { lat: 35.753268, lon: 139.706889 },
            { lat: 35.765875, lon: 139.702340 },
            { lat: 35.767558, lon: 139.696580 },
            { lat: 35.771376, lon: 139.691611 },
            { lat: 35.777087, lon: 139.672814 },
            { lat: 35.785651, lon: 139.639855 },
            { lat: 35.806119, lon: 139.647151 },
            { lat: 35.815376, lon: 139.645864 },
            { lat: 35.823049, lon: 139.640341 },
            { lat: 35.823954, lon: 139.642315 },
            { lat: 35.816177, lon: 139.649699 },
            { lat: 35.806154, lon: 139.651244 },
            { lat: 35.789446, lon: 139.646781 },
            { lat: 35.783319, lon: 139.674590 },
            { lat: 35.768277, lon: 139.705489 },
            { lat: 35.752154, lon: 139.711524 },
          ]]
        },
        {
          name: '5号池袋線（東京西地区）',
          coords: [[
            // from left bottom, clock wise
            { lat: 35.690467, lon: 139.755054 },
            { lat: 35.694405, lon: 139.752050 },
            { lat: 35.702003, lon: 139.749045 },
            { lat: 35.702526, lon: 139.743767 },
            { lat: 35.707056, lon: 139.741922 },
            { lat: 35.709495, lon: 139.726515 },
            { lat: 35.710924, lon: 139.726429 },
            { lat: 35.723032, lon: 139.721480 },
            { lat: 35.726586, lon: 139.715816 },
            { lat: 35.733344, lon: 139.714614 },
            { lat: 35.740938, lon: 139.705001 },
            { lat: 35.744143, lon: 139.706460 },
            { lat: 35.753268, lon: 139.706889 },
            { lat: 35.752154, lon: 139.711524 },
            { lat: 35.750343, lon: 139.713670 },
            { lat: 35.748880, lon: 139.713584 },
            { lat: 35.748531, lon: 139.709464 },
            { lat: 35.741635, lon: 139.709121 },
            { lat: 35.736689, lon: 139.717961 },
            { lat: 35.728119, lon: 139.718562 },
            { lat: 35.724565, lon: 139.723969 },
            { lat: 35.719478, lon: 139.728604 },
            { lat: 35.711255, lon: 139.733325 },
            { lat: 35.708467, lon: 139.745084 },
            { lat: 35.704059, lon: 139.745956 },
            { lat: 35.703641, lon: 139.750633 },
            { lat: 35.699006, lon: 139.753423 },
            { lat: 35.695486, lon: 139.754582 },
            { lat: 35.692175, lon: 139.758744 },
            { lat: 35.691791, lon: 139.759688 },
            { lat: 35.690676, lon: 139.759646 },
          ]]
        },
        {
          name: '6号三郷線',
          coords: [[
            // from left bottom, clock wise
            { lat: 35.752659, lon: 139.819165 },
            { lat: 35.761209, lon: 139.818637 },
            { lat: 35.791569, lon: 139.826533 },
            { lat: 35.797000, lon: 139.825589 },
            { lat: 35.802917, lon: 139.827048 },
            { lat: 35.811200, lon: 139.840781 },
            { lat: 35.818578, lon: 139.846704 },
            { lat: 35.832288, lon: 139.853570 },
            { lat: 35.836045, lon: 139.856402 },
            { lat: 35.838828, lon: 139.856402 },
            { lat: 35.838480, lon: 139.862496 },
            { lat: 35.833471, lon: 139.862239 },
            { lat: 35.832983, lon: 139.857947 },
            { lat: 35.814889, lon: 139.847734 },
            { lat: 35.810435, lon: 139.844129 },
            { lat: 35.808555, lon: 139.842498 },
            { lat: 35.801594, lon: 139.831168 },
            { lat: 35.791709, lon: 139.829795 },
            { lat: 35.761418, lon: 139.821641 },
            { lat: 35.752570, lon: 139.822137 },
          ]]
        },
        {
          name: '6号向島線',
          coords: [[
            // from left bottom, clock wise
            { lat: 35.683718, lon: 139.776368 },
            { lat: 35.685496, lon: 139.777569 },
            { lat: 35.684067, lon: 139.780531 },
            { lat: 35.680894, lon: 139.782590 },
            { lat: 35.685844, lon: 139.791045 },
            { lat: 35.690306, lon: 139.787139 },
            { lat: 35.691996, lon: 139.788456 },
            { lat: 35.696667, lon: 139.788456 },
            { lat: 35.712209, lon: 139.799872 },
            { lat: 35.720641, lon: 139.808198 },
            { lat: 35.732417, lon: 139.810429 },
            { lat: 35.743007, lon: 139.816437 },
            { lat: 35.744696, lon: 139.822073 },
            { lat: 35.746194, lon: 139.823489 },
            { lat: 35.742815, lon: 139.825291 },
            { lat: 35.743233, lon: 139.822716 },
            { lat: 35.741300, lon: 139.818111 },
            { lat: 35.739140, lon: 139.816652 },
            { lat: 35.735065, lon: 139.816539 },
            { lat: 35.730466, lon: 139.812934 },
            { lat: 35.717784, lon: 139.809673 },
            { lat: 35.710537, lon: 139.802291 },
            { lat: 35.695795, lon: 139.792104 },
            { lat: 35.692589, lon: 139.790645 },
            { lat: 35.690986, lon: 139.790817 },
            { lat: 35.689731, lon: 139.789615 },
            { lat: 35.685199, lon: 139.793220 },
            { lat: 35.682252, lon: 139.789460 },
            { lat: 35.678855, lon: 139.781805 },
            { lat: 35.682568, lon: 139.778685 },
          ]]
        },
        {
          name: '7号小松川線',
          coords: [[
            // from left bottom, clock wise
            { lat: 35.690236, lon: 139.789414 },
            { lat: 35.691160, lon: 139.788556 },
            { lat: 35.692659, lon: 139.791238 },
            { lat: 35.696135, lon: 139.845862 },
            { lat: 35.699272, lon: 139.851484 },
            { lat: 35.700544, lon: 139.868294 },
            { lat: 35.700544, lon: 139.868208 },
            { lat: 35.698871, lon: 139.879366 },
            { lat: 35.699150, lon: 139.892241 },
            { lat: 35.702914, lon: 139.897047 },
            { lat: 35.703541, lon: 139.900909 },
            { lat: 35.701520, lon: 139.901596 },
            { lat: 35.696710, lon: 139.893700 },
            { lat: 35.696222, lon: 139.877993 },
            { lat: 35.696571, lon: 139.852587 },
            { lat: 35.693155, lon: 139.847094 },
            { lat: 35.690750, lon: 139.791105 },
          ]]
        },
        {
          name: '9号深川線',
          coords: [[
            // from right top, counter clock wise
            { lat: 35.683650, lon: 139.789046 },
            { lat: 35.681001, lon: 139.783939 },
            { lat: 35.680199, lon: 139.784369 },
            { lat: 35.680722, lon: 139.786107 },
            { lat: 35.678944, lon: 139.787566 },
            { lat: 35.676025, lon: 139.793146 },
            { lat: 35.673236, lon: 139.794949 },
            { lat: 35.671562, lon: 139.803446 },
            { lat: 35.663334, lon: 139.804304 },
            { lat: 35.658801, lon: 139.806622 },
            { lat: 35.655593, lon: 139.809626 },
            { lat: 35.645411, lon: 139.811342 },
            { lat: 35.642760, lon: 139.803875 },
            { lat: 35.640528, lon: 139.804819 },
            { lat: 35.644922, lon: 139.820269 },
            { lat: 35.647294, lon: 139.819582 },
            { lat: 35.646178, lon: 139.814175 },
            { lat: 35.656640, lon: 139.812458 },
            { lat: 35.663404, lon: 139.807051 },
            { lat: 35.673073, lon: 139.805484 },
            { lat: 35.674920, lon: 139.796858 },
            { lat: 35.677430, lon: 139.795527 },
            { lat: 35.679999, lon: 139.789198 },
            { lat: 35.681324, lon: 139.787653 },
            { lat: 35.682849, lon: 139.789754 },
          ]]
        },
        {
          name: '10号晴海線',
          coords: [[
            // from left top, counter clock wise
            { lat: 35.654376, lon: 139.781801 },
            { lat: 35.647250, lon: 139.788527 },
            { lat: 35.638697, lon: 139.794906 },
            { lat: 35.636535, lon: 139.791902 },
            { lat: 35.635000, lon: 139.793275 },
            { lat: 35.640162, lon: 139.803918 },
            { lat: 35.642115, lon: 139.802630 },
            { lat: 35.639953, lon: 139.797309 },
            { lat: 35.648253, lon: 139.790271 },
            { lat: 35.655147, lon: 139.783003 },
          ]]
        },
        {
          name: '11号台場線',
          coords: [[
            // from left top, counter clock wise
            { lat: 35.649877, lon: 139.757989 },
            { lat: 35.646494, lon: 139.756143 },
            { lat: 35.644751, lon: 139.756830 },
            { lat: 35.637427, lon: 139.757045 },
            { lat: 35.633904, lon: 139.769190 },
            { lat: 35.635683, lon: 139.777343 },
            { lat: 35.631427, lon: 139.781893 },
            { lat: 35.629020, lon: 139.778116 },
            { lat: 35.627695, lon: 139.779232 },
            { lat: 35.633555, lon: 139.790433 },
            { lat: 35.635055, lon: 139.789274 },
            { lat: 35.632439, lon: 139.784339 },
            { lat: 35.638438, lon: 139.777944 },
            { lat: 35.636101, lon: 139.769833 },
            { lat: 35.639066, lon: 139.759104 },
            { lat: 35.646320, lon: 139.758332 },
            { lat: 35.649424, lon: 139.759491 },
          ]]
        },
        {
          name: '都心環状線',
          coords: [
            [
              // from 竹橋、counter clock wise
              { lat: 35.692077, lon: 139.754890 },
              { lat: 35.689568, lon: 139.744719 },
              { lat: 35.683538, lon: 139.743217 },
              { lat: 35.679389, lon: 139.744890 },
              { lat: 35.677089, lon: 139.747980 },
              { lat: 35.667885, lon: 139.738281 },
              { lat: 35.661644, lon: 139.736994 },
              { lat: 35.659238, lon: 139.735578 },
              { lat: 35.655263, lon: 139.736865 },
              { lat: 35.653903, lon: 139.745019 },
              { lat: 35.653937, lon: 139.744848 },
              { lat: 35.652507, lon: 139.747166 },
              { lat: 35.652123, lon: 139.749783 },
              { lat: 35.652646, lon: 139.751586 },
              { lat: 35.651775, lon: 139.760813 },
              { lat: 35.659028, lon: 139.760899 },
              { lat: 35.666594, lon: 139.768323 },
              { lat: 35.668407, lon: 139.769825 },
              { lat: 35.671440, lon: 139.773086 },
              { lat: 35.674159, lon: 139.773644 },
              { lat: 35.683153, lon: 139.778880 },
              { lat: 35.683920, lon: 139.780125 },
              { lat: 35.685349, lon: 139.777764 },
              { lat: 35.685245, lon: 139.771885 },
              { lat: 35.689393, lon: 139.768924 },
              { lat: 35.690264, lon: 139.764589 },
              { lat: 35.692146, lon: 139.760984 },
            ],
            [
              { lat: 35.690633, lon: 139.755435 },
              { lat: 35.688563, lon: 139.751064 },
              { lat: 35.688267, lon: 139.746277 },
              { lat: 35.683492, lon: 139.745133 },
              { lat: 35.679984, lon: 139.747214 },
              { lat: 35.676814, lon: 139.750179 },
              { lat: 35.671784, lon: 139.746850 },
              { lat: 35.671108, lon: 139.744196 },
              { lat: 35.666881, lon: 139.740034 },
              { lat: 35.661386, lon: 139.738733 },
              { lat: 35.656566, lon: 139.738473 },
              { lat: 35.653776, lon: 139.758816 },
              { lat: 35.659610, lon: 139.758400 },
              { lat: 35.664725, lon: 139.762563 },
              { lat: 35.672165, lon: 139.770992 },
              { lat: 35.675081, lon: 139.771564 },
              { lat: 35.683699, lon: 139.777413 },
              { lat: 35.683319, lon: 139.773667 },
              { lat: 35.684080, lon: 139.770441 },
              { lat: 35.687798, lon: 139.767580 },
              { lat: 35.688813, lon: 139.763521 },
              { lat: 35.690714, lon: 139.760608 },
            ]
          ]
        },
        {
          name: '中央環状線（東京東地区）',
          coords: [[
            // from left top, clock wise
            { lat: 35.750217, lon: 139.706877 },
            { lat: 35.750774, lon: 139.713400 },
            { lat: 35.750531, lon: 139.722042 },
            { lat: 35.747048, lon: 139.728393 },
            { lat: 35.754292, lon: 139.739723 },
            { lat: 35.757914, lon: 139.741096 },
            { lat: 35.759028, lon: 139.745559 },
            { lat: 35.766871, lon: 139.760673 },
            { lat: 35.767567, lon: 139.763334 },
            { lat: 35.762901, lon: 139.766853 },
            { lat: 35.760464, lon: 139.776037 },
            { lat: 35.762762, lon: 139.791658 },
            { lat: 35.763841, lon: 139.801931 },
            { lat: 35.761613, lon: 139.810857 },
            { lat: 35.756737, lon: 139.817037 },
            { lat: 35.754369, lon: 139.822874 },
            { lat: 35.749632, lon: 139.823217 },
            { lat: 35.738486, lon: 139.829225 },
            { lat: 35.725527, lon: 139.843473 },
            { lat: 35.705039, lon: 139.862699 },
            { lat: 35.693607, lon: 139.862356 },
            { lat: 35.686915, lon: 139.860296 },
            { lat: 35.676039, lon: 139.853601 },
            { lat: 35.661117, lon: 139.852056 },
            { lat: 35.657351, lon: 139.853944 },
            { lat: 35.647896, lon: 139.852980 },
            { lat: 35.647199, lon: 139.857873 },
            { lat: 35.645281, lon: 139.857529 },
            { lat: 35.646048, lon: 139.844869 },
            { lat: 35.648245, lon: 139.844998 },
            { lat: 35.648106, lon: 139.847787 },
            { lat: 35.656375, lon: 139.848451 },
            { lat: 35.659862, lon: 139.846391 },
            { lat: 35.678270, lon: 139.847593 },
            { lat: 35.681756, lon: 139.849138 },
            { lat: 35.693747, lon: 139.856348 },
            { lat: 35.703366, lon: 139.855661 },
            { lat: 35.709639, lon: 139.850340 },
            { lat: 35.720789, lon: 139.840555 },
            { lat: 35.735142, lon: 139.826135 },
            { lat: 35.756041, lon: 139.810686 },
            { lat: 35.759384, lon: 139.802446 },
            { lat: 35.757294, lon: 139.776697 },
            { lat: 35.759245, lon: 139.766912 },
            { lat: 35.764399, lon: 139.761762 },
            { lat: 35.757809, lon: 139.748883 },
            { lat: 35.755790, lon: 139.743904 },
            { lat: 35.753143, lon: 139.742832 },
            { lat: 35.752551, lon: 139.741973 },
            { lat: 35.744505, lon: 139.729914 },
            { lat: 35.744435, lon: 139.726824 },
            { lat: 35.748058, lon: 139.721073 },
            { lat: 35.748789, lon: 139.709143 },
          ]]
        },
        {
          name: '中央環状線（東京西地区）',
          coords: [[
            // from right top, counter clock wise
            { lat: 35.743878, lon: 139.706962 },
            { lat: 35.735170, lon: 139.698551 },
            { lat: 35.727993, lon: 139.694860 },
            { lat: 35.718238, lon: 139.686535 },
            { lat: 35.707296, lon: 139.681041 },
            { lat: 35.702139, lon: 139.681127 },
            { lat: 35.689801, lon: 139.680011 },
            { lat: 35.680808, lon: 139.686878 },
            { lat: 35.661563, lon: 139.686191 },
            { lat: 35.657518, lon: 139.689195 },
            { lat: 35.653543, lon: 139.687908 },
            { lat: 35.650431, lon: 139.689494 },
            { lat: 35.647737, lon: 139.692191 },
            { lat: 35.644145, lon: 139.698071 },
            { lat: 35.633403, lon: 139.706868 },
            { lat: 35.628240, lon: 139.710473 },
            { lat: 35.622101, lon: 139.722618 },
            { lat: 35.620670, lon: 139.724507 },
            { lat: 35.620077, lon: 139.726567 },
            { lat: 35.620042, lon: 139.730086 },
            { lat: 35.618089, lon: 139.733090 },
            { lat: 35.615682, lon: 139.735107 },
            { lat: 35.615019, lon: 139.739270 },
            { lat: 35.617426, lon: 139.749827 },
            { lat: 35.617042, lon: 139.751672 },
            { lat: 35.615856, lon: 139.752616 },
            { lat: 35.606296, lon: 139.751758 },
            { lat: 35.605180, lon: 139.754204 },
            { lat: 35.604447, lon: 139.756307 },
            { lat: 35.610344, lon: 139.756221 },
            { lat: 35.611495, lon: 139.753818 },
            { lat: 35.616379, lon: 139.754204 },
            { lat: 35.618926, lon: 139.752230 },
            { lat: 35.619345, lon: 139.749269 },
            { lat: 35.616658, lon: 139.739613 },
            { lat: 35.616903, lon: 139.736008 },
            { lat: 35.618996, lon: 139.734849 },
            { lat: 35.621856, lon: 139.730214 },
            { lat: 35.621822, lon: 139.726137 },
            { lat: 35.622903, lon: 139.724936 },
            { lat: 35.629566, lon: 139.711847 },
            { lat: 35.637379, lon: 139.706268 },
            { lat: 35.639716, lon: 139.704379 },
            { lat: 35.645087, lon: 139.699916 },
            { lat: 35.646726, lon: 139.697513 },
            { lat: 35.649341, lon: 139.693522 },
            { lat: 35.651364, lon: 139.690732 },
            { lat: 35.654363, lon: 139.690518 },
            { lat: 35.657815, lon: 139.691891 },
            { lat: 35.658059, lon: 139.691805 },
            { lat: 35.662173, lon: 139.688672 },
            { lat: 35.670192, lon: 139.688930 },
            { lat: 35.676956, lon: 139.688887 },
            { lat: 35.679152, lon: 139.689616 },
            { lat: 35.682115, lon: 139.689616 },
            { lat: 35.690167, lon: 139.682664 },
            { lat: 35.696336, lon: 139.683565 },
            { lat: 35.699682, lon: 139.684166 },
            { lat: 35.702644, lon: 139.683437 },
            { lat: 35.706861, lon: 139.684080 },
            { lat: 35.717628, lon: 139.688973 },
            { lat: 35.724283, lon: 139.695367 },
            { lat: 35.728847, lon: 139.698328 },
            { lat: 35.734246, lon: 139.700903 },
            { lat: 35.738113, lon: 139.704980 },
            { lat: 35.742589, lon: 139.708671 },
            { lat: 35.743565, lon: 139.709186 },
          ]]
        },
        {
          name: '八重洲線',
          coords: [[
            // from left bottom, clock wise
            { lat: 35.662968, lon: 139.762055 },
            { lat: 35.664104, lon: 139.762939 },
            { lat: 35.664479, lon: 139.763078 },
            { lat: 35.665577, lon: 139.762853 },
            { lat: 35.666580, lon: 139.762263 },
            { lat: 35.666946, lon: 139.761791 },
            { lat: 35.668053, lon: 139.758572 },
            { lat: 35.668454, lon: 139.758315 },
            { lat: 35.672424, lon: 139.760396 },
            { lat: 35.672659, lon: 139.760729 },
            { lat: 35.673626, lon: 139.763700 },
            { lat: 35.676170, lon: 139.765538 },
            { lat: 35.684101, lon: 139.770742 },
            { lat: 35.688162, lon: 139.767459 },
            { lat: 35.688650, lon: 139.766075 },
            { lat: 35.689295, lon: 139.766182 },
            { lat: 35.688650, lon: 139.768435 },
            { lat: 35.685835, lon: 139.770377 },
            { lat: 35.684084, lon: 139.771536 },
            { lat: 35.683805, lon: 139.771407 },
            { lat: 35.682358, lon: 139.770656 },
            { lat: 35.680585, lon: 139.769571 },
            { lat: 35.679609, lon: 139.771728 },
            { lat: 35.679051, lon: 139.771363 },
            { lat: 35.679914, lon: 139.769164 },
            { lat: 35.676075, lon: 139.766804 },
            { lat: 35.672951, lon: 139.764130 },
            { lat: 35.672794, lon: 139.763529 },
            { lat: 35.672158, lon: 139.760782 },
            { lat: 35.668523, lon: 139.758948 },
            { lat: 35.667198, lon: 139.762542 },
            { lat: 35.666152, lon: 139.763132 },
            { lat: 35.665281, lon: 139.763529 },
            { lat: 35.664052, lon: 139.763497 },
            { lat: 35.663389, lon: 139.763175 },
            { lat: 35.662631, lon: 139.762563 },
          ]]
        },
        {
          name: '埼玉川口線',
          coords: [[
            // from left bottom, clock wise
            { lat: 35.765108, lon: 139.761727 },
            { lat: 35.770707, lon: 139.758946 },
            { lat: 35.775722, lon: 139.748183 },
            { lat: 35.780944, lon: 139.743393 },
            { lat: 35.786250, lon: 139.747050 },
            { lat: 35.787963, lon: 139.751427 },
            { lat: 35.797308, lon: 139.760411 },
            { lat: 35.808848, lon: 139.757813 },
            { lat: 35.809934, lon: 139.757607 },
            { lat: 35.818578, lon: 139.758894 },
            { lat: 35.825510, lon: 139.758379 },
            { lat: 35.834404, lon: 139.755032 },
            { lat: 35.837535, lon: 139.754105 },
            { lat: 35.841960, lon: 139.750397 },
            { lat: 35.844841, lon: 139.745556 },
            { lat: 35.847429, lon: 139.735617 },
            { lat: 35.849850, lon: 139.733093 },
            { lat: 35.851687, lon: 139.732733 },
            { lat: 35.852897, lon: 139.730518 },
            { lat: 35.856111, lon: 139.733866 },
            { lat: 35.853231, lon: 139.737162 },
            { lat: 35.850894, lon: 139.735205 },
            { lat: 35.848389, lon: 139.737728 },
            { lat: 35.845592, lon: 139.748389 },
            { lat: 35.842211, lon: 139.753178 },
            { lat: 35.836658, lon: 139.756525 },
            { lat: 35.824591, lon: 139.760491 },
            { lat: 35.816908, lon: 139.761006 },
            { lat: 35.808555, lon: 139.759770 },
            { lat: 35.796296, lon: 139.762550 },
            { lat: 35.786250, lon: 139.752972 },
            { lat: 35.784453, lon: 139.748595 },
            { lat: 35.781028, lon: 139.746638 },
            { lat: 35.777978, lon: 139.748646 },
            { lat: 35.771125, lon: 139.762242 },
            { lat: 35.764983, lon: 139.764096 },
          ]]
        },
        {
          name: '埼玉大宮線',
          coords: [[
            // from left bottom, clock wise
            { lat: 35.821954, lon: 139.641626 },
            { lat: 35.836281, lon: 139.628817 },
            { lat: 35.837534, lon: 139.627701 },
            { lat: 35.862857, lon: 139.619376 },
            { lat: 35.873638, lon: 139.618346 },
            { lat: 35.889859, lon: 139.611664 },
            { lat: 35.891006, lon: 139.608403 },
            { lat: 35.893196, lon: 139.609476 },
            { lat: 35.896430, lon: 139.617200 },
            { lat: 35.895213, lon: 139.618016 },
            { lat: 35.892014, lon: 139.614325 },
            { lat: 35.889268, lon: 139.614497 },
            { lat: 35.873916, lon: 139.621838 },
            { lat: 35.861953, lon: 139.622868 },
            { lat: 35.837742, lon: 139.630764 },
            { lat: 35.822529, lon: 139.642892 },
          ]]
        },
        {
          name: '埼玉新都心線',
          coords: [[
            // from left top, clock wise
            { lat: 35.894690, lon: 139.613678 },
            { lat: 35.896498, lon: 139.616811 },
            { lat: 35.899418, lon: 139.625651 },
            { lat: 35.899348, lon: 139.630372 },
            { lat: 35.894620, lon: 139.634406 },
            { lat: 35.898653, lon: 139.648654 },
            { lat: 35.898132, lon: 139.650971 },
            { lat: 35.895155, lon: 139.657697 },
            { lat: 35.895833, lon: 139.663705 },
            { lat: 35.894842, lon: 139.664027 },
            { lat: 35.893756, lon: 139.658356 },
            { lat: 35.894242, lon: 139.655652 },
            { lat: 35.897158, lon: 139.648353 },
            { lat: 35.896602, lon: 139.645521 },
            { lat: 35.892291, lon: 139.632646 },
            { lat: 35.893508, lon: 139.629127 },
            { lat: 35.897089, lon: 139.627325 },
            { lat: 35.897749, lon: 139.624407 },
            { lat: 35.894933, lon: 139.617197 },
            { lat: 35.893438, lon: 139.614407 },
          ]]
        },
        {
          name: '湾岸線（東京地区）',
          coords: [[
            // from left bottom, clock wise
            { lat: 35.520126, lon: 139.791205 },
            { lat: 35.533101, lon: 139.794066 },
            { lat: 35.540994, lon: 139.790805 },
            { lat: 35.557544, lon: 139.777930 },
            { lat: 35.567878, lon: 139.758876 },
            { lat: 35.570740, lon: 139.757417 },
            { lat: 35.585121, lon: 139.753812 },
            { lat: 35.586656, lon: 139.753554 },
            { lat: 35.613455, lon: 139.754413 },
            { lat: 35.627270, lon: 139.772609 },
            { lat: 35.633269, lon: 139.784368 },
            { lat: 35.642896, lon: 139.802564 },
            { lat: 35.647639, lon: 139.817069 },
            { lat: 35.649382, lon: 139.838698 },
            { lat: 35.647429, lon: 139.860671 },
            { lat: 35.639199, lon: 139.883588 },
            { lat: 35.640315, lon: 139.888309 },
            { lat: 35.662215, lon: 139.914744 },
            { lat: 35.671349, lon: 139.923242 },
            { lat: 35.684248, lon: 139.938949 },
            { lat: 35.689755, lon: 139.948476 },
            { lat: 35.687524, lon: 139.950193 },
            { lat: 35.680553, lon: 139.938691 },
            { lat: 35.668072, lon: 139.924443 },
            { lat: 35.660680, lon: 139.917749 },
            { lat: 35.658797, lon: 139.915689 },
            { lat: 35.636618, lon: 139.888223 },
            { lat: 35.635850, lon: 139.884017 },
            { lat: 35.644430, lon: 139.857753 },
            { lat: 35.646159, lon: 139.836565 },
            { lat: 35.643638, lon: 139.815554 },
            { lat: 35.639243, lon: 139.802877 },
            { lat: 35.623607, lon: 139.773622 },
            { lat: 35.609986, lon: 139.756955 },
            { lat: 35.584468, lon: 139.756866 },
            { lat: 35.569109, lon: 139.762363 },
            { lat: 35.559230, lon: 139.781778 },
            { lat: 35.537519, lon: 139.797115 },
            { lat: 35.531386, lon: 139.796760 },
            { lat: 35.518616, lon: 139.792948 },
          ]]
        },
        {
          name: '湾岸線（神奈川地区）',
          coords: [[
            // from right top, counter clock wise
            { lat: 35.520492, lon: 139.791441 },
            { lat: 35.514142, lon: 139.786920 },
            { lat: 35.505915, lon: 139.772647 },
            { lat: 35.500575, lon: 139.760767 },
            { lat: 35.465347, lon: 139.680891 },
            { lat: 35.460075, lon: 139.675572 },
            { lat: 35.443827, lon: 139.665466 },
            { lat: 35.438843, lon: 139.666264 },
            { lat: 35.429236, lon: 139.669987 },
            { lat: 35.418472, lon: 139.669100 },
            { lat: 35.413776, lon: 139.660944 },
            { lat: 35.420567, lon: 139.649597 },
            { lat: 35.413487, lon: 139.626636 },
            { lat: 35.397446, lon: 139.614313 },
            { lat: 35.391231, lon: 139.614579 },
            { lat: 35.381040, lon: 139.623888 },
            { lat: 35.376558, lon: 139.639757 },
            { lat: 35.362906, lon: 139.642244 },
            { lat: 35.362906, lon: 139.644562 },
            { lat: 35.376467, lon: 139.644350 },
            { lat: 35.380526, lon: 139.641947 },
            { lat: 35.386124, lon: 139.623750 },
            { lat: 35.392701, lon: 139.618601 },
            { lat: 35.395920, lon: 139.618601 },
            { lat: 35.410611, lon: 139.629072 },
            { lat: 35.416767, lon: 139.649328 },
            { lat: 35.410964, lon: 139.661997 },
            { lat: 35.415648, lon: 139.672159 },
            { lat: 35.429916, lon: 139.673189 },
            { lat: 35.432574, lon: 139.672846 },
            { lat: 35.442784, lon: 139.669412 },
            { lat: 35.461889, lon: 139.680954 },
            { lat: 35.464982, lon: 139.685704 },
            { lat: 35.502339, lon: 139.770448 },
            { lat: 35.510619, lon: 139.785511 },
            { lat: 35.515255, lon: 139.792151 },
            { lat: 35.519980, lon: 139.793021 },
          ]]
        },
        {
          name: '神奈川1号横羽線',
          coords: [[
            // from right top, counter clock wise
            { lat: 35.544866, lon: 139.742627 },
            { lat: 35.540769, lon: 139.740460 },
            { lat: 35.540691, lon: 139.737334 },
            { lat: 35.537164, lon: 139.737141 },
            { lat: 35.537129, lon: 139.740553 },
            { lat: 35.534339, lon: 139.740652 },
            { lat: 35.526871, lon: 139.735745 },
            { lat: 35.518831, lon: 139.724082 },
            { lat: 35.515408, lon: 139.721214 },
            { lat: 35.512243, lon: 139.712739 },
            { lat: 35.509753, lon: 139.709616 },
            { lat: 35.500519, lon: 139.692919 },
            { lat: 35.489934, lon: 139.663922 },
            { lat: 35.489727, lon: 139.660863 },
            { lat: 35.487288, lon: 139.656976 },
            { lat: 35.481165, lon: 139.640661 },
            { lat: 35.476598, lon: 139.636073 },
            { lat: 35.475767, lon: 139.633588 },
            { lat: 35.470422, lon: 139.628617 },
            { lat: 35.467619, lon: 139.623391 },
            { lat: 35.465698, lon: 139.622690 },
            { lat: 35.459729, lon: 139.623072 },
            { lat: 35.452877, lon: 139.628553 },
            { lat: 35.451112, lon: 139.631739 },
            { lat: 35.447063, lon: 139.631293 },
            { lat: 35.443169, lon: 139.635563 },
            { lat: 35.438496, lon: 139.644230 },
            { lat: 35.441693, lon: 139.651428 },
            { lat: 35.442567, lon: 139.650913 },
            { lat: 35.440295, lon: 139.644776 },
            { lat: 35.442611, lon: 139.641122 },
            { lat: 35.444674, lon: 139.636530 },
            { lat: 35.448345, lon: 139.633139 },
            { lat: 35.451246, lon: 139.633869 },
            { lat: 35.452470, lon: 139.633182 },
            { lat: 35.454707, lon: 139.629964 },
            { lat: 35.460300, lon: 139.624985 },
            { lat: 35.465666, lon: 139.625315 },
            { lat: 35.468322, lon: 139.627375 },
            { lat: 35.469511, lon: 139.631152 },
            { lat: 35.474823, lon: 139.635958 },
            { lat: 35.475871, lon: 139.638276 },
            { lat: 35.481393, lon: 139.644971 },
            { lat: 35.483630, lon: 139.652009 },
            { lat: 35.486285, lon: 139.659304 },
            { lat: 35.490898, lon: 139.672522 },
            { lat: 35.497956, lon: 139.691577 },
            { lat: 35.501659, lon: 139.699387 },
            { lat: 35.509205, lon: 139.712348 },
            { lat: 35.511162, lon: 139.714837 },
            { lat: 35.514236, lon: 139.723506 },
            { lat: 35.520174, lon: 139.729256 },
            { lat: 35.526671, lon: 139.737925 },
            { lat: 35.534284, lon: 139.742560 },
            { lat: 35.541007, lon: 139.742187 },
            { lat: 35.544429, lon: 139.743561 },
          ]]
        },
        {
          name: '神奈川2号三ツ沢線',
          coords: [[
            // from left top, clock wise
            { lat: 35.473255, lon: 139.602808 },
            { lat: 35.472625, lon: 139.604589 },
            { lat: 35.471350, lon: 139.606413 },
            { lat: 35.471262, lon: 139.607894 },
            { lat: 35.471560, lon: 139.610426 },
            { lat: 35.471297, lon: 139.611713 },
            { lat: 35.469026, lon: 139.616284 },
            { lat: 35.468012, lon: 139.624545 },
            { lat: 35.469165, lon: 139.626884 },
            { lat: 35.468571, lon: 139.627699 },
            { lat: 35.465653, lon: 139.624352 },
            { lat: 35.465880, lon: 139.623343 },
            { lat: 35.467086, lon: 139.623772 },
            { lat: 35.468029, lon: 139.616284 },
            { lat: 35.468309, lon: 139.614932 },
            { lat: 35.470721, lon: 139.610447 },
            { lat: 35.470144, lon: 139.606563 },
            { lat: 35.470703, lon: 139.604911 },
            { lat: 35.472119, lon: 139.603538 },
            { lat: 35.472398, lon: 139.602572 },
          ]]
        },
        {
          name: '神奈川3号狩場線',
          coords: [[
            // from left top, clock wise
            { lat: 35.442588, lon: 139.580813 },
            { lat: 35.443422, lon: 139.589321 },
            { lat: 35.442369, lon: 139.593360 },
            { lat: 35.440000, lon: 139.598906 },
            { lat: 35.439298, lon: 139.604291 },
            { lat: 35.437236, lon: 139.606876 },
            { lat: 35.437280, lon: 139.612153 },
            { lat: 35.433595, lon: 139.619045 },
            { lat: 35.433507, lon: 139.621361 },
            { lat: 35.437850, lon: 139.636223 },
            { lat: 35.438289, lon: 139.639130 },
            { lat: 35.439956, lon: 139.640961 },
            { lat: 35.441053, lon: 139.640584 },
            { lat: 35.441799, lon: 139.642307 },
            { lat: 35.440614, lon: 139.645323 },
            { lat: 35.444124, lon: 139.654692 },
            { lat: 35.443729, lon: 139.658515 },
            { lat: 35.438772, lon: 139.664331 },
            { lat: 35.439561, lon: 139.666269 },
            { lat: 35.443203, lon: 139.666054 },
            { lat: 35.443247, lon: 139.668316 },
            { lat: 35.432322, lon: 139.671331 },
            { lat: 35.432015, lon: 139.669662 },
            { lat: 35.435569, lon: 139.667993 },
            { lat: 35.437017, lon: 139.663469 },
            { lat: 35.442545, lon: 139.656038 },
            { lat: 35.441887, lon: 139.652700 },
            { lat: 35.436534, lon: 139.639400 },
            { lat: 35.436271, lon: 139.635522 },
            { lat: 35.432103, lon: 139.623407 },
            { lat: 35.432849, lon: 139.616137 },
            { lat: 35.435876, lon: 139.610753 },
            { lat: 35.435701, lon: 139.605153 },
            { lat: 35.438114, lon: 139.602676 },
            { lat: 35.438859, lon: 139.597075 },
            { lat: 35.441974, lon: 139.589375 },
            { lat: 35.441053, lon: 139.583290 },
            { lat: 35.437105, lon: 139.582644 },
            { lat: 35.437148, lon: 139.580706 },
          ]]
        },
        {
          name: '神奈川5号大黒線',
          coords: [[
            // from left top, clock wise
            { lat: 35.492592, lon: 139.669790 },
            { lat: 35.492172, lon: 139.672665 },
            { lat: 35.490845, lon: 139.672064 },
            { lat: 35.483576, lon: 139.676442 },
            { lat: 35.477426, lon: 139.675626 },
            { lat: 35.472393, lon: 139.676141 },
            { lat: 35.470611, lon: 139.677128 },
            { lat: 35.465368, lon: 139.678073 },
            { lat: 35.465787, lon: 139.682407 },
            { lat: 35.467115, lon: 139.686184 },
            { lat: 35.465543, lon: 139.687385 },
            { lat: 35.460299, lon: 139.682407 },
            { lat: 35.459915, lon: 139.679446 },
            { lat: 35.462991, lon: 139.676699 },
            { lat: 35.474106, lon: 139.674253 },
            { lat: 35.478369, lon: 139.673867 },
            { lat: 35.483192, lon: 139.674511 },
            { lat: 35.485079, lon: 139.673781 },
            { lat: 35.490286, lon: 139.670734 },
            { lat: 35.490810, lon: 139.668975 },
          ]]
        },
        {
          name: '神奈川6号川崎線',
          coords: [[
            // from left top, clock wise
            { lat: 35.537791, lon: 139.745872 },
            { lat: 35.538541, lon: 139.759036 },
            { lat: 35.519490, lon: 139.792135 },
            { lat: 35.517743, lon: 139.790418 },
            { lat: 35.536952, lon: 139.758103 },
            { lat: 35.536708, lon: 139.750678 },
            { lat: 35.536568, lon: 139.746129 },
          ]]
        },
        {
          name: '神奈川7号横浜北線',
          coords: [[
            // from left top, clock wise
            { lat: 35.517805, lon: 139.594219 },
            { lat: 35.518713, lon: 139.597996 },
            { lat: 35.517735, lon: 139.604562 },
            { lat: 35.515849, lon: 139.609969 },
            { lat: 35.516652, lon: 139.619024 },
            { lat: 35.516233, lon: 139.624818 },
            { lat: 35.515255, lon: 139.630096 },
            { lat: 35.513927, lon: 139.634173 },
            { lat: 35.510294, lon: 139.638894 },
            { lat: 35.495272, lon: 139.656060 },
            { lat: 35.492686, lon: 139.660609 },
            { lat: 35.492372, lon: 139.663785 },
            { lat: 35.493525, lon: 139.669536 },
            { lat: 35.492372, lon: 139.671638 },
            { lat: 35.489821, lon: 139.672368 },
            { lat: 35.489471, lon: 139.671595 },
            { lat: 35.491952, lon: 139.668935 },
            { lat: 35.490555, lon: 139.663313 },
            { lat: 35.490869, lon: 139.660094 },
            { lat: 35.494153, lon: 139.653914 },
            { lat: 35.512845, lon: 139.631856 },
            { lat: 35.515115, lon: 139.619410 },
            { lat: 35.514137, lon: 139.610742 },
            { lat: 35.514591, lon: 139.607222 },
            { lat: 35.516652, lon: 139.602030 },
            { lat: 35.517421, lon: 139.597052 },
            { lat: 35.516827, lon: 139.594219 },
          ]]
        },
        {
          name: '神奈川7号横浜北西線',
          coords: [[
            // from left top, clock wise
            { lat: 35.547060, lon: 139.537372 },
            { lat: 35.546249, lon: 139.538956 },
            { lat: 35.544766, lon: 139.539809 },
            { lat: 35.541425, lon: 139.540330 },
            { lat: 35.538563, lon: 139.540507 },
            { lat: 35.532237, lon: 139.544347 },
            { lat: 35.531257, lon: 139.547666 },
            { lat: 35.527568, lon: 139.575928 },
            { lat: 35.525440, lon: 139.578975 },
            { lat: 35.520053, lon: 139.583270 },
            { lat: 35.516990, lon: 139.587323 },
            { lat: 35.516702, lon: 139.589092 },
            { lat: 35.519070, lon: 139.591593 },
            { lat: 35.517818, lon: 139.594051 },
            { lat: 35.516789, lon: 139.594120 },
            { lat: 35.515347, lon: 139.591368 },
            { lat: 35.515088, lon: 139.589635 },
            { lat: 35.515755, lon: 139.586295 },
            { lat: 35.518252, lon: 139.582376 },
            { lat: 35.520184, lon: 139.580618 },
            { lat: 35.523298, lon: 139.578068 },
            { lat: 35.526207, lon: 139.574381 },
            { lat: 35.529875, lon: 139.546452 },
            { lat: 35.530771, lon: 139.543062 },
            { lat: 35.533303, lon: 139.541275 },
            { lat: 35.535528, lon: 139.539752 },
            { lat: 35.540325, lon: 139.538320 },
            { lat: 35.543612, lon: 139.536706 },
          ]]
        },
      ]
    },
    getRoadInfos() {
      const ret = this.getRoadInfos_()
      ret.forEach(e => {
        e.coords.forEach((linePoints_, i) => {
          if (linePoints_.length === 0) { return }
          // coordsはpolygon作成用に使うが、polygonの引数は
          // linear ringの配列になっていなければならない.
          // (最初の要素と最後の要素が同じ点を示している配列をlinear ring
          //  と呼んでいる模様.)
          // 最初のlinear ringが外郭、以降は外郭内の穴を表現する.
          const linePoints = linePoints_.slice()
          const first = linePoints[0]
          const last = linePoints[linePoints.length - 1]
          if (first[0] !== last[0] || first[1] !== last[1]) {
            linePoints.push(linePoints[0])
          }
          e.coords[i] = linePoints.map(convCoord)
        })
      })
      return ret
    },
  }
}
